<template>
  <div>
    <FiltersTable 
      :getOrderButton="true" 
      titleButton="Obtener órdenes" 
      searchPlaceholder="Buscar por 'Órden ML'"
      @onSearch="onSearch"
      @getOrders="getOrders"/>
    <div>
      <!-- <vs-button vs-button color="primary" type="border" class="mb-3 px-3" :disabled="!canProcessManySelected" @click="processManySelected" >
				<feather-icon icon="FastForwardIcon" svgClasses="h-3 w-3"/>
				Procesar {{canProcessManySelected ? canProcessManySelected : '' }} Seleccionadas
			</vs-button> -->
      <!-- <vs-button vs-button color="primary" type="border" class="mb-3 px-3" disabled >
				<feather-icon icon="FastForwardIcon" svgClasses="h-3 w-3"/>
				Procesar Seleccionadas
			</vs-button> -->
    </div>

    <div v-if="showDetailModal">
        <OrderDetails :orderDetail="orderDetail" @orderDetail="handleOrderDetail" />
    </div>

    <div v-if="showProcessModal || showArchiveModal">
        <!-- Cotizacion manual: SOLO ME1. En Flex el despacho es directo, sin cotizacion. -->
        <PedingProcess v-if="mode !== 'flex'" :orderProcess="orderProcess" @orderProcess="handleOrderProcess" @closeModal="handleCloseModal"/>
    </div>

    <!-- Sin direccion de retiro el backend responde FLEX_BRANCH_NOT_CONFIGURED: conviene decirlo antes del click. -->
    <div v-if="mode === 'flex' && flexOriginMissing" class="flex-branch-warning">
      Todavía no cargaste la <strong>dirección de retiro</strong> de los envíos Flex, así que no se
      puede crear ninguno.
      <router-link to="/meli-flex/configuracion">Configurarla ahora</router-link>.
    </div>

    <!-- Barra de acciones en lote: solo Flex, y solo con algo seleccionado -->
    <div v-if="mode === 'flex' && selected.length" class="flex items-center mb-4">
      <span class="mr-4">{{ selected.length }} orden(es) seleccionada(s)</span>
      <vs-button type="border" size="small" :disabled="creatingShipments || flexOriginMissing" @click="confirmCreateFlexShipments()">
        {{ creatingShipments ? 'Creando...' : 'Crear envíos Flex' }}
      </vs-button>
      <vs-button type="border" size="small" class="ml-2" :disabled="printingLabels" @click="printSelectedLabels()">
        {{ printingLabels ? 'Generando...' : 'Imprimir etiquetas de Meli' }}
      </vs-button>
      <vs-button type="flat" size="small" class="ml-2" @click="selected = []">Limpiar</vs-button>
    </div>

    <VxTable 
			stripe
			:multiple="mode === 'flex'"
			:only-click-checkbox="mode === 'flex'"
			v-model="selected"
			:data="orders" 
			pagination 
			:max-items="30"
			:total="totalItems"
			:sst="true" 
			@change-page="handleChangePage">
			
      <template slot="thead">
        <vs-th>Órden ML</vs-th>
        <vs-th>Comprador</vs-th>
        <!-- <vs-th>Destinatario</vs-th>
        <vs-th>DNI facturación</vs-th> -->
        <vs-th v-if="mode === 'flex'" style="min-width: 160px">Producto</vs-th>
        <vs-th style="min-width: 90px">Valor compra</vs-th>
        <vs-th v-if="mode === 'flex'" style="min-width: 140px">Destino</vs-th>
        <vs-th style="min-width: 140px">Fecha</vs-th>
        <!-- "Actualizada" y "Modo" salen del panel Flex: la solapa ya filtra por Flex, y esos dos lugares se usan para Producto y Destino. -->
        <vs-th v-if="mode !== 'flex'" style="min-width: 130px">Actualizada</vs-th>
        <vs-th v-if="mode !== 'flex'" style="min-width: 80px">Modo</vs-th>
        <!-- Aca solo queda el fallo de conexion: el resto manda la orden a Invalidas. -->
        <vs-th v-if="mode === 'flex'" style="min-width: 160px">Motivo del fallo</vs-th>
        <vs-th style="min-width: 110px" >Acciones</vs-th>
      </template>

      <template slot-scope="{ data }">
        <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
          <vs-td>
            {{ data[indextr].id }}
            <br v-if="data[indextr].pack_id" />
            <small v-if="data[indextr].pack_id" class="order-pack-id">
              N° compra: {{ data[indextr].pack_id }}
            </small>
          </vs-td>
          <vs-td>
            Cuenta: <br /><em
              >{{ tr.buyer.first_name }} {{ tr.buyer.last_name }} ({{
                tr.buyer.nickname
              }}).</em
            >
            <br />
            <template
              v-if="tr.shipment_data && tr.shipment_data.receiver_address"
            >
              Recibe: <br />
              <em>{{ tr.shipment_data.receiver_address.receiver_name }} </em>
            </template>
          </vs-td>
          <vs-td v-if="mode === 'flex'">{{ productSummary(tr) }}</vs-td>
          <vs-td> $ {{ tr.total_amount }} </vs-td>
          <vs-td v-if="mode === 'flex'">{{ destinationLabel(tr) }}</vs-td>
          <vs-td>
            {{ data[indextr].date_created | formatDate }}
          </vs-td>
          <vs-td v-if="mode !== 'flex'">
            {{ data[indextr].last_updated | formatDateFromNow }}
          </vs-td>
          <vs-td v-if="mode !== 'flex'">
            {{ orderModeLabel(tr) }}
          </vs-td>
          <vs-td v-if="mode === 'flex'">
            {{ tr.flex_error || "—" }}
          </vs-td>
          <vs-td>
            <!-- <vs-button
              type="border"
              size="small"
              color="primary"
              class="w-full mb-1"
              @click="openPopupDetalle(data[indextr])"
            > -->
              <feather-icon class="order-action" @click="openDetails(tr)" title="Ver el detalle" icon="EyeIcon" svgClasses="h-5 w-5 mx-1 cursor-pointer" />
              <!-- Detalle -->
            <!-- </vs-button> -->
            <!-- <vs-button
              type="border"
              size="small"
              color="success"
              class="w-full mb-1"
              @click="openPopupProcesar(data[indextr])"
            > -->
              <!-- ME1: abre el popup de cotizacion -->
              <feather-icon class="order-action" v-if="mode !== 'flex'" @click="openProcess(tr)" title="Cotizar y despachar" icon="TruckIcon" svgClasses="h-5 w-5 mx-1 cursor-pointer" />
              <!-- Flex: crea el envio en un solo paso, sin cotizacion -->
              <feather-icon class="order-action" v-else-if="!flexOriginMissing && canDispatch(tr)" @click="confirmCreateFlexShipment(tr)" title="Despachar con Flex" icon="TruckIcon" svgClasses="h-5 w-5 mx-1 cursor-pointer" />
              <!-- Cancelada en Meli: el despacho fallaria con ORDER_CANCELLED, asi que se previene antes del click. -->
              <feather-icon v-else-if="!flexOriginMissing" :title="dispatchBlockedReason(tr)" icon="TruckIcon" svgClasses="h-5 w-5 mx-1 opacity-25 cursor-not-allowed" />
              <!-- Etiqueta de Meli: solo Flex -->
              <feather-icon class="order-action" v-if="mode === 'flex' && hasLabelAvailable(tr)" @click="printLabel(tr)" title="Imprimir la etiqueta" icon="PrinterIcon" svgClasses="h-5 w-5 mx-1 cursor-pointer" />
              <!-- Meli no tiene etiqueta para este estado: se previene el pedido en vez de recibir un PDF corto sin aviso (§9.3). -->
              <feather-icon v-else-if="mode === 'flex'" :title="labelUnavailableTooltip(tr)" icon="PrinterIcon" svgClasses="h-5 w-5 mx-1 opacity-25 cursor-not-allowed" />
              <!-- Procesar -->
            <!-- </vs-button> -->
            <!-- <vs-button
              type="border"
              size="small"
              color="danger"
              @click="openPopupArchive(data[indextr])"
              class="w-full mb-1"
            > -->
              <feather-icon class="order-action" @click="openArchive(tr)" title="Desestimar la orden" icon="FolderIcon" svgClasses="h-5 w-5 mx-1 cursor-pointer" />
              <!-- Desestimar -->
            <!-- </vs-button> -->
          </vs-td>
        </vs-tr>
      </template>
    </VxTable>
  

    <!-- POPUP Desestimar (Archive) -->
    <vs-popup
      class=""
      :title="'Desestimar Órden'"
      :active.sync="popupArchive.open"
      v-if="popupArchive.open"
    >
      <p class="mb-2">
        <strong
          >¿Confirma que desea desestimar la órden #{{
            popupArchive.order.id
          }}?</strong
        >
      </p>
      <p class="mb-4">
        La órden pasará a la seción "Desestimadas" donde no podrá procesarla.
      </p>

      <p class="mb-1 text-right">
        <vs-button
          type="border"
          color="success"
          @click="doArchiveOrder()"
          class="mr-2"
        >
          Si, desestimar esta órden
        </vs-button>
        <vs-button type="border" color="danger" @click="closePopupArchive()">
          Cancelar
        </vs-button>
      </p>
    </vs-popup>

  </div>
</template>

<script>
// Extraer:
// MOMENTJS and CONFIG
// AXIOS and CONFIG
// FILTERS

// import _ from "lodash"; // ya esta improtado en archivo local pero si no lo improto aca da errores aveces

import moment from "moment";
// `_.reject` se usaba sin importar lodash: main.js no crea un global. Era un ReferenceError.
import _ from "lodash";
import { orderModeLabel, hasLabelAvailable, labelUnavailableTooltip, labelUnavailableShort, productSummary, destinationLabel } from "../../utils/orderLabels";
moment.locale("es");

import axios from "axios";
axios.defaults.withCredentials = true;

import OrderDetails from "../../components/modals/Orders/OrderDetails.vue";
import PedingProcess from "../../components/modals/Orders/Pending/PedingProcess.vue";
import FiltersTable from "../../components/filters-table/FiltersTable.vue"
import { createFlexShipment, createFlexShipments, normalizeBatchResult, downloadFlexLabel, downloadFlexLabels, saveBlob, readBlobError } from "../../services/meliFlex.service";
import { errorMessage } from "../../http";
import { showAlertMessage, showConfirmation, showError, showSuccess } from "../../services/alert.service";
import { escapeHtml } from "../../utils/html";


export default {
  components: {
    OrderDetails,
    PedingProcess,
    FiltersTable
  },
  props: {
    // ME1 o Flex — lo inyectan las rutas (ver router.js); default ME1.
    mode: { type: String, default: 'me1' }
  },
  data() {
    return {
      orders: [],
      ordersPreserved: [], // used when reseting local filtering
      totalItems: 0, // SST
      selected: [], // Los items seleccionados con el checkbox
      creatingShipments: false,
      printingLabels: false,

      // Popup (detalle & proccesar)
      popupOrder: {}, // El item en que se ha clickeado Detalle o Procesar
      popupOrderShipmentInfo: null,

      // Popup - detalle
      popupDetalleActive: false,
      // Popup - procesar
      popupProcesarActive: false,

      // Popup - procesar - cotizar
      popupOrderQuotations: {
        available: [],
        fetching: false,
        choosen: null,
        error: null, //
      },

      ancho: null,
      largo: null,
      alto: null,
      peso: null,

      // Popup - procesar - despachar
      isProcessingOrder: false,
      showDimensionsInputs: false,
      processedOrder: false,
      processingErrorMsg: "",
      processingSuccessMsg: "",

      // Popup - desestimar (archive)
      popupArchive: {
        open: false,
        order: {},
      },

      filtersSelected: [],

      processManyShowPopup: false,

      // New data for show modal
      showDetailModal: false,
      orderDetail: {},

      showProcessModal: false,
      showArchiveModal: false,
      orderProcess: {},


    };
  },

  filters: {
    formatDate(rawDate) {
      return moment(rawDate).format("D-M-Y");
    },
    formatDateFromNow(rawDate) {
      return moment(rawDate).fromNow();
    },
  },

  watch: {
    // Las rutas ME1 y Flex montan ESTE MISMO componente: Vue reutiliza la instancia y no vuelve a ejecutar mounted().
    mode() {
      this.page = 1;
      this.orders = [];
      this.ordersPreserved = [];
      this.totalItems = 0;
      this.selected = [];
      this.loadOrders(1);
    }
  },
  mounted() {
    this.loadOrders();
  },

  computed: {
    /** Sin la direccion de retiro el backend responde FLEX_ORIGIN_NOT_CONFIGURED. `flex_origin_unit` es el unico opcional. */
    flexOriginMissing() {
      const user = this.$store.state.authUser || {};
      return ['street', 'number', 'zip', 'city', 'province']
        .some((field) => !String(user[`flex_origin_${field}`] || '').trim());
    },

    /**
     * @bool Se deben mostrar las posibles cotizaciones para seleccioanr una?
     */
    popupShowQuotations() {
      return (
        this.popupOrderQuotations.available.length &&
        !this.isProcessingOrder &&
        !this.processedOrder
      );
    },

    qoutationCustomDimensionsEnableContinue() {
      return this.ancho && this.alto && this.largo && this.peso;
    },
  },

  methods: {
    orderModeLabel,
    productSummary,
    destinationLabel,
    // Se exponen porque el template los usa: un import de modulo no es visible ahi.
    hasLabelAvailable,
    labelUnavailableTooltip,
    loadOrders(page = 1) {
      this.$vs.loading();

      this.filtersSelected['page'] = page;
      this.filtersSelected['mode'] = this.mode;

      try {
        const filtersSelected = this.filtersSelected;
        const query = Object.keys(filtersSelected)
          .map(key => encodeURIComponent(key) + '=' + encodeURIComponent(filtersSelected[key]))
          .join('&');

        return axios.get(process.env.VUE_APP_BACKEND_URL + 'api/orders-pending?' + query)
          .then(orders => {

            const body = orders.data.body || [];
            const paging = orders.data.paging || {};

            // Si `body` no viniera, antes la grilla se quedaba con las filas anteriores.
            this.orders = body;
            this.ordersPreserved = body;

            // `total` puede ser 0 en una busqueda sin resultados: con un `if` el paginador seguia en la consulta previa.
            this.totalItems = paging.total || 0;
          })
          .catch(e => {
            console.log(e);
          })
          .finally(() => {
            this.$vs.loading.close();
          });

      } catch (e) {
        console.log(e);
        this.$vs.loading.close(); 
      }
    },

    handleChangePage(page) {
      // Si la seleccion sobrevive se puede disparar un lote sobre ordenes que el operador ya no ve.
      this.selected = [];
      this.loadOrders(page);
    },

    getNewOrders(page = 1) {
      axios
        .get(process.env.VUE_APP_BACKEND_URL + "api/getNewOrders")
        .then(() => this.loadOrders(page))
        .catch((error) => {
          console.log(error);
        });
    },

    /** Desestimar. Puede responder 422 ORDER_ALREADY_PROCESSED: sacarla de Procesadas la esconderia con el envio vivo. */
    async doArchiveOrder() {
      const order = this.popupArchive.order;
      const shipmentId = order && order.shipping && order.shipping.id;

      // La URL lleva los dos ids. Sin envio no se puede armar, y antes reventaba con un TypeError.
      if (!shipmentId) {
        this.closePopupArchive();
        showError({ message: 'La orden no tiene envío asociado, así que no se puede desestimar.' });
        return;
      }

      this.$vs.loading();
      const url = `${process.env.VUE_APP_BACKEND_URL}api/archive-order/${order.id}/${shipmentId}`;

      try {
        await axios.post(url);
        this.closePopupArchive();
        showSuccess({ message: 'La orden pasó a Desestimadas.' });
        // Se recarga en vez de sacar la fila a mano: cambiaron tambien el total y el paginado.
        this.loadOrders(this.filtersSelected.page || 1);
      } catch (e) {
        this.closePopupArchive();
        const status = e.response && e.response.status;
        if (status && status !== 401 && status !== 419) {
          showError({ message: errorMessage(e, 'No se pudo desestimar la orden.') });
        }
      }
    },

    closePopupArchive() {
      this.$vs.loading.close();

      this.popupArchive.open = false;
      this.popupArchive.order = {};
    },

    randomCenter() {
      function getRandomInt(min, max) {
        return Math.floor(Math.random() * (max - min)) + min;
      }
      let color = `rgb(${getRandomInt(0, 255)},${getRandomInt(
        0,
        255
      )},${getRandomInt(0, 255)})`;
      this.$vs.notify({
        title: "Órdenes",
        text: "Órdenes Obtenidas Correctamente",
        color: color,
        position: "top-center",
      });
    },

    // NEW METHODS FOR ACTIONS
    openDetails(tr) {
      this.orderDetail = tr;
      this.showDetailModal = true;
    },
    handleOrderDetail() {
      this.showDetailModal = false;
    },
    openProcess(tr) {
      // Defensa en profundidad: la cotizacion manual no debe alcanzarse nunca en Flex.
      if (this.mode === 'flex') return;

      this.orderProcess = tr;
      this.orderProcess.archive = false;
      this.showProcessModal = true;
    },

    /** Etiqueta individual. El parametro es el id del ENVIO, no el de la orden. */
    async printLabel(tr) {
      const shipmentId = tr.shipment_data && tr.shipment_data.id;
      if (!shipmentId) {
        showError({ message: "La orden no tiene un envío asociado." });
        return;
      }

      // El boton ya viene deshabilitado en estos casos; esto cubre la llamada por codigo.
      if (!hasLabelAvailable(tr)) {
        showError({ message: labelUnavailableTooltip(tr) });
        return;
      }

      this.$vs.loading();
      try {
        const { data } = await downloadFlexLabel(shipmentId);
        saveBlob(data, `etiqueta-${shipmentId}.pdf`);
      } catch (e) {
        await this.showLabelError(e, "No se pudo obtener la etiqueta.");
      } finally {
        this.$vs.loading.close();
      }
    },

    /** Lote: el backend devuelve un unico PDF con todas las etiquetas. */
    /** Filtra las seleccionadas por etiqueta disponible ANTES de pedir el lote y avisa cuales quedan afuera (§9.3). Devuelve null si no hay que llamar. */
    async pickPrintableSelection() {
      const withShipment = this.selected.filter((o) => o && o.shipment_data && o.shipment_data.id);

      if (!withShipment.length) {
        showError({ message: "Ninguna de las órdenes seleccionadas tiene envío asociado." });
        return null;
      }

      const printable = withShipment.filter(hasLabelAvailable);
      const skipped = withShipment.filter((o) => !hasLabelAvailable(o));
      const detalle = skipped
        .map((o) => `• #${escapeHtml(String(o.id))} — ${escapeHtml(labelUnavailableShort(o))}`)
        .join("<br>");

      if (!printable.length) {
        await showAlertMessage({
          title: "Ninguna tiene etiqueta disponible",
          text: `No se puede imprimir ninguna de las ${skipped.length} órdenes seleccionadas:<br><br>${detalle}`,
          error: true,
          html: true,
          textCloseButton: "Entendido",
        });
        return null;
      }

      if (skipped.length) {
        const { isConfirmed } = await showConfirmation({
          title: `${printable.length} de ${withShipment.length} órdenes tienen etiqueta disponible`,
          text: `No se van a incluir:<br><br>${detalle}`,
          textConfirmButton: `Imprimir las ${printable.length}`,
          popupClass: "swal-popup-auto",
          html: true,
        });
        if (!isConfirmed) return null;
      }

      return printable;
    },

    async printSelectedLabels() {
      const printable = await this.pickPrintableSelection();
      if (!printable) return;

      const ids = printable.map((o) => o.shipment_data.id);

      this.printingLabels = true;
      this.$vs.loading();
      try {
        const { data } = await downloadFlexLabels(ids);
        saveBlob(data, 'etiquetas-flex.pdf');
        // Ahora el numero se puede afirmar: se pidieron solo las que tienen etiqueta.
        showSuccess({ message: `${ids.length} etiqueta(s) generada(s).` });
        this.selected = [];
      } catch (e) {
        await this.showLabelError(e, "No se pudieron obtener las etiquetas.");
      } finally {
        this.printingLabels = false;
        this.$vs.loading.close();
      }
    },

    /** Con responseType blob el error tambien llega como Blob: hay que leerlo. */
    async showLabelError(e, fallback) {
      const status = e.response && e.response.status;
      if (status === 401 || status === 419) return; // ya avisa el interceptor
      const message = await readBlobError(e);
      showError({ message: message || fallback });
    },

    /** Flex en lote. El backend NO falla en bloque: responde { summary, results[] } y hay que reportar orden por orden. */
    async confirmCreateFlexShipments() {
      const ids = this.selected.map((o) => o && o.id).filter(Boolean);
      if (!ids.length) return;

      const { isConfirmed } = await showConfirmation({
        title: 'Crear envíos Flex',
        text: `Se crearán ${ids.length} envío(s) directamente, sin cotización. ¿Continuar?`,
        textConfirmButton: 'Sí, crear',
        popupClass: 'swal-popup-auto'
      });

      if (!isConfirmed) return;

      this.creatingShipments = true;
      this.$vs.loading();

      // Se declara afuera porque se usa despues de recargar: la re-seleccion solo puede hacerse con los objetos nuevos.
      let fallidas = [];
      let resultado = null;
      let fallo = null;

      // Solo el pedido va dentro del try; todo lo que muestra interfaz va despues de cerrar el loader.
      try {
        const { data } = await createFlexShipments(ids);
        resultado = normalizeBatchResult(data);
      } catch (e) {
        fallo = e;
      } finally {
        // El loader se cierra ANTES de abrir un modal que espera un click, o su boton queda inalcanzable bajo el overlay.
        this.creatingShipments = false;
        this.$vs.loading.close();
      }

      if (fallo) {
        // El tope de cantidad lo define el backend y viene en el mensaje del 422.
        const status = fallo.response && fallo.response.status;
        if (status && status !== 401 && status !== 419) {
          showError({ message: errorMessage(fallo, 'No se pudieron crear los envíos.') });
        }
      } else {
        const { summary, failed } = resultado;

        fallidas = failed.map((r) => String(r.meli_order_id));

        if (failed.length) {
          // El texto lleva markup a proposito (`html: true`), asi que lo que viene del backend se escapa aca.
          const detalle = failed
            .map((r) => `• #${escapeHtml(r.meli_order_id)} — ${escapeHtml(r.message || r.error_code || 'error')}`)
            .join('<br>');

          // Modal que NO se autocierra: con varias fallas listadas un toast se pierde.
          await showAlertMessage({
            title: `${summary.succeeded} de ${summary.total} envíos creados`,
            text: `No se pudieron crear ${failed.length} envío(s):<br><br>${detalle}<br><br>Quedan seleccionadas para reintentar.`,
            error: true,
            html: true,
            textCloseButton: 'Entendido'
          });
        } else {
          showSuccess({ message: `${summary.succeeded} envío(s) creados.` });
        }
      }

      // Al recargar, `orders` trae objetos NUEVOS: hay que reapuntar la seleccion por id o los checkboxes quedan destildados.
      await this.loadOrders(this.filtersSelected.page || 1);
      this.selected = fallidas.length
        ? this.orders.filter((o) => fallidas.includes(String(o.id)))
        : [];
    },

    /** Flex: despacho directo, sin cotizacion ni seleccion de servicio. */
    async confirmCreateFlexShipment(tr) {
      // showConfirmation devuelve el resultado de SweetAlert, no un booleano.
      const { isConfirmed } = await showConfirmation({
        title: 'Crear envío Flex',
        text: `Se creará el envío de la orden #${tr.id} directamente, sin cotización. ¿Continuar?`,
        textConfirmButton: 'Sí, crear el envío',
        popupClass: 'swal-popup-auto'
      });

      if (!isConfirmed) return;

      this.$vs.loading();

      let respuesta = null;
      let fallo = null;

      // Solo el pedido va dentro del try, porque `reportShipmentError` puede abrir un modal que espera un click.
      try {
        const { data } = await createFlexShipment(tr.id);
        respuesta = data;
      } catch (e) {
        fallo = e;
      } finally {
        // Antes de cualquier modal: con MISSING_DIMENSIONS se abre una confirmacion que no se autocierra.
        this.$vs.loading.close();
      }

      if (fallo) {
        // El interceptor ya avisa sesion vencida / timeout / sin conexion.
        const status = fallo.response && fallo.response.status;
        if (status && status !== 401 && status !== 419) {
          const body = (fallo.response && fallo.response.data) || {};
          await this.reportShipmentError(body.error_code, errorMessage(fallo, 'No se pudo crear el envío.'));
        }
      } else if (respuesta && respuesta.success === false) {
        await this.reportShipmentError(respuesta.error_code, respuesta.message);
      } else {
        showSuccess({ message: 'Envio creado correctamente.' });
      }

      // Se recarga tambien tras un error: salvo CDS_UNAVAILABLE, el fallo manda la orden a Invalidas en el momento.
      this.loadOrders(this.filtersSelected.page || 1);
    },
    /** El backend verifica contra ML y responde ORDER_CANCELLED. `meli_status` es el codigo crudo; el label NO se usa para logica. */
    canDispatch(tr) {
      return !tr || tr.meli_status !== 'cancelled';
    },

    dispatchBlockedReason(tr) {
      if (tr && tr.meli_status === 'cancelled') {
        return 'La compra se canceló en Mercado Libre: no se puede despachar.';
      }
      return '';
    },

    openArchive(tr) {
      this.popupArchive.order = tr;
      this.popupArchive.open = true;
    },
    /** `error_code` es un conjunto ABIERTO: default siempre, nunca una lista cerrada. Los `message` del backend ya son texto de interfaz. */
    async reportShipmentError(errorCode, message) {
      const text = message || 'No se pudo crear el envío.';

      if (errorCode !== 'MISSING_DIMENSIONS') {
        showError({ message: text });
        return;
      }

      const { isConfirmed } = await showConfirmation({
        title: 'Faltan las medidas del producto',
        text: `${text} Sin las medidas y el peso, Cruz del Sur no toma el envío.`,
        textConfirmButton: 'Editar la publicación',
        popupClass: 'swal-popup-auto'
      });

      if (isConfirmed) this.$router.push('/catalogo');
    },

    handleOrderProcess() {
      this.orders = _.reject(this.orders, { id: this.orderProcess.id });
      this.showProcessModal = false;
      this.showArchiveModal = false;
    },
    handleCloseModal() {
      this.showProcessModal = false;
      this.showArchiveModal = false;
    },

    getOrders(){
      this.getNewOrders();
    },

    onSearch(value){
      this.filtersSelected = value;
      // Buscar filtra lo que ya esta; no sincroniza contra Mercado Libre. Antes esto pasaba
      // por getNewOrders(), que pega a `api/getNewOrders` —lento, consulta ML— y recien
      // despues lista: cada tecla encadenaba esa espera. Las otras tres solapas ya hacian
      // esto. La sincronizacion vive en el boton "Obtener ordenes".
      this.loadOrders(1);
    },


    async fetchOrderShipmentInfo(shipmentId) {
      try {
        let shipmentInfo = await axios.get(
          process.env.VUE_APP_BACKEND_URL +
            "api/order-shipment-info/" +
            shipmentId
        );
        if (shipmentInfo.data) {
          //this.popupOrderShipmentInfo = shipmentInfo.data
          return shipmentInfo.data;
        }
      } catch (e) {
        console.log(e);
      }
    },
  },
};
</script>
